export default __webpack_public_path__ + "static/media/DHL_Logo.034bbd95.svg";